module.exports = "<div class=\"alertWrapper\">\n    <clr-alert *ngIf=\"message\" [clrAlertType]=\"message.type\" [clrAlertAppLevel]=\"true\" [clrAlertClosable]=\"false\">\n        <clr-alert-item>\n            <span class=\"alert-text\">\n                {{message.text}}\n            </span>\n        </clr-alert-item>\n    </clr-alert>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/alert/alert.component.html
// module id = ./src/app/common/alert/alert.component.html
// module chunks = main